import hooks from './users.hooks';

export default (app) => {
  const service = app.service('api/users');
  service.hooks(hooks);
};
